import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import http from "../../../utils/http";

type Payload={
  appointmentId: string
}
export const useStartRecord = () => {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation({
    mutationKey: ["start recording"],
    mutationFn: async ({ appointmentId }: Payload) => {
      const response = await http.post("/meeting/record/start", { appointmentId });
      return response.data;
    },

    onMutate: () => {
      const toastId = toast.loading("Please wait...");
      return { toastId };
    },
    onSuccess: (_data, _variables, context) => {
      const { toastId } = context;
      toast.update(toastId, {
        render: "Recording started...",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
        toastId: 'recording-started',
      })
      queryClient.invalidateQueries({ queryKey: ['attendee information'] as const});
    },

    onError: (error, _variables, context) => {
      const toastId = context?.toastId as number

      if (axios.isAxiosError(error)) {
        toast.update(toastId, {
          render: error?.response?.data?.error || "Error starting recording",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
          toastId: 'recording-error',
        })

      } else {
        toast.update(toastId, {
          render: error?.message || "An unexpected error occured while starting recording",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });

      }
    }
  });

  return { startRecording: mutate, ...rest };
}